import { Heading } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export function DetailsHeader(): JSX.Element {
  return <Heading variant="h3">1. Meal credit details</Heading>;
}
